/**
 * @generated SignedSource<<a37dd377d83c0496f902229c04bceae0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
import { FragmentRefs } from "relay-runtime";
export type BookingSummary_booking$data = {
  readonly __typename: string;
  readonly id: string;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly restrictionStatuses?: {
    readonly groupStatuses: {
      readonly statuses: ReadonlyArray<{
        readonly restriction: {
          readonly name: string;
        };
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly roundStatuses: ReadonlyArray<{
      readonly statuses: ReadonlyArray<{
        readonly restriction: {
          readonly name: string;
        };
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly __typename: string;
    readonly agenda: {
      readonly facility: {
        readonly club: {
          readonly phoneNumber: {
            readonly formattedNumber: string;
          } | null | undefined;
          readonly supportsPrivate: boolean;
        } | null | undefined;
        readonly privateLessonsPermissionSet: {
          readonly patronAccess: LessonAccess | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"RemoteLockCode_BookingSummaryRemoteLockCodeConfig">;
      };
    };
    readonly id: string;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentSpreads": FragmentRefs<"AvailableTeeTimes_booking" | "BookingConfirmedModal_Booking" | "BookingCreditSelectModals_booking" | "BookingDetailsView_Booking" | "BookingHeaderFragment_booking" | "BookingInfo_Booking" | "BookingPaymentMethodSelect_booking" | "BookingPayment_Booking" | "BookingPolicy_Booking" | "BookingReservation_Booking" | "ChargesSummary_booking" | "InviteOthersBox_Booking" | "LessonInfoBanner_booking" | "MemberNote_Booking" | "PaymentCardEntryModals_booking" | "RemoteLockCode_Booking" | "RequestInfoBanner_booking" | "useGetBookingAnalyticsMetadata_booking" | "useGetFullfillableSlots_booking" | "useInitializePunchPassesFromBooking" | "useShouldPresentBookingAsLockedRequest_booking">;
  readonly " $fragmentType": "BookingSummary_booking";
};
export type BookingSummary_booking$key = {
  readonly " $data"?: BookingSummary_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingSummary_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "patronLoyalty",
    "variableName": "patronLoyalty"
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RestrictionStatus",
    "kind": "LinkedField",
    "name": "statuses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "restriction",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BookingRuleStatuses",
    "kind": "LinkedField",
    "name": "restrictionStatuses",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GroupBookingRuleStatus",
        "kind": "LinkedField",
        "name": "groupStatuses",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RoundBookingRuleStatus",
        "kind": "LinkedField",
        "name": "roundStatuses",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "useInitializePunchPassesFromBooking"
  }
],
v5 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingSummary_booking",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBookingAnalyticsMetadata_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoteLockCode_Booking"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "ChargesSummary_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCardEntryModals_booking"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "BookingPayment_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InviteOthersBox_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingInfo_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingDetailsView_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingPolicy_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingPaymentMethodSelect_booking"
    },
    {
      "args": (v2/*: any*/),
      "kind": "FragmentSpread",
      "name": "BookingReservation_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingHeaderFragment_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MemberNote_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestInfoBanner_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonInfoBanner_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvailableTeeTimes_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldPresentBookingAsLockedRequest_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingCreditSelectModals_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetFullfillableSlots_booking"
    },
    {
      "kind": "InlineFragment",
      "selections": (v4/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v4/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v5/*: any*/),
          "type": "Customer",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v5/*: any*/),
          "type": "Member",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhoneNumber",
                      "kind": "LinkedField",
                      "name": "phoneNumber",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formattedNumber",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PrivateLessonsPermissionSet",
                  "kind": "LinkedField",
                  "name": "privateLessonsPermissionSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "patronAccess",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RemoteLockCode_BookingSummaryRemoteLockCodeConfig"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingConfirmedModal_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "680410fc041a324d0c1f674fe972bcde";

export default node;
